export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const PREVIEW_SECONDS = 30;

export const THEMES = {
  red: {
    bg: "#7a0a0f",
    glow: "radial-gradient(60% 50% at 30% 20%, rgba(255,40,40,0.35) 0%, transparent 70%), radial-gradient(80% 60% at 80% 100%, rgba(0,0,0,0.55) 0%, transparent 70%)",
    accent: "#ff3b3b",
    panel: "rgba(20,0,2,0.38)",
  },
  dark: {
    bg: "#07060a",
    glow: "radial-gradient(55% 45% at 25% 15%, rgba(126,92,255,0.16) 0%, transparent 70%), radial-gradient(60% 50% at 90% 90%, rgba(60,40,140,0.12) 0%, transparent 70%)",
    accent: "#a08bff",
    panel: "rgba(255,255,255,0.035)",
  },
};

export const fmtTime = (s) => {
  const t = Math.max(0, Math.floor(s || 0));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
};
